import React, { useContext } from 'react';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import AppointmentDeskContext from '../../AppointmentDeskContext';
import PlanContainer from './PlanContainer';
import AppointmentDeskPlan from './AppointmentDeskPlan';
import LiveConciergePlan from './LiveConciergePlan';

const MyPlan: React.FC = () => {
  const { sm } = useBreakpoint();
  const { answeringSubscription, association } = useContext(
    AppointmentDeskContext,
  );

  const hasAppointmentDesk =
    association?.useAppointmentDesk || association?.useLiveConciergePlus;
  const currentPlan = answeringSubscription?.serviceType;

  return (
    <StyledPlanBody $sm={sm}>
      {hasAppointmentDesk && (
        <PlanContainer
          isCurrentPlan={
            hasAppointmentDesk &&
            currentPlan !== AnsweringServiceType.LiveConciergePlus
          }
        >
          <AppointmentDeskPlan />
        </PlanContainer>
      )}
      <PlanContainer
        isCurrentPlan={currentPlan === AnsweringServiceType.LiveConciergePlus}
      >
        <LiveConciergePlan />
      </PlanContainer>
    </StyledPlanBody>
  );
};

export default MyPlan;

const StyledPlanBody = styled.div<{ $sm: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;
